module.exports = __webpack_public_path__ + "img/profile_box_gray_licenses.45edd49f.svg";